import React, { useState, useEffect } from "react";
import green from "@material-ui/core/colors/green";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import classes from "./NotificationDetails.module.scss";
import CircularProgress from "../../components/CircularProgress";
import { useTranslation } from "react-i18next";

const styles = (theme) => ({
  buttonProgress: {
    color: green[500],
  },
});

const NotificationDetails = ({
  open,
  handleRequestClose,
  detailData,
  detailsLoading,
  groupData,
  userData,
}) => {
  const { t, i18n } = useTranslation();
  const [userList, setUserList] = useState([]);
  const [groupList, setGroupList] = useState([]);

  useEffect(() => {
    if (detailData.length !== 0) {
      setUserList(
        userData.filter((user) => {
          return detailData?.receivers.find(
            (receiver) => receiver === user.uuid
          );
        })
      );
      setGroupList(
        groupData.filter((group) => {
          return detailData?.receivers.find(
            (receiver) => receiver === group.uuid
          );
        })
      );
    }
  }, [detailData]);

  return (
    <>
      <div className={classes.root}>
        <Dialog
          open={open}
          onClose={handleRequestClose}
          className={classes.dialogRoot}
          fullWidth
          maxWidth="md"
        >
          {detailsLoading ? (
            <div style={{ height: "100px" }}>
              <CircularProgress />
            </div>
          ) : (
            <div
              className="w-100 text-center"
              style={{ maxWidth: "100%", borderRadius: "1.6rem" }}
            >
              <div className="w-100 p-4 text-center d-flex justify-content-center">
                <h2>{t("notifications.notificationDetailTitle")}</h2>
              </div>
              <div
                style={{ direction: i18n.dir() }}
                className={classes.container}
              >
                <div className={classes.contentContainer}>
                  <div className={classes.title}>
                    <h2>{t("notifications.message_title")}: </h2>
                    <h2>{detailData.subject}</h2>
                  </div>
                  <div className={classes.text}>
                    <p>{t("notifications.message_text")}: </p>
                    <p>{detailData.message}</p>
                  </div>
                </div>
                <div className={classes.listContainer}>
                  <p>{t("notifications.receiversList")}</p>
                  {userList.length !== 0 && (
                    <ul className={classes.list}>
                      {userList.map((user) => (
                        <li>{user.first_name + " " + user.last_name}</li>
                      ))}
                    </ul>
                  )}
                  {groupList.length !== 0 && (
                    <ul className={classes.list}>
                      {groupList.map((group) => (
                        <li>{group.title}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          )}
        </Dialog>
      </div>
    </>
  );
};

export default withStyles(styles)(NotificationDetails);
